import { Flex, Box, Image } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

import { routes } from "config/routes";
import Stopwatch from "images/random/stopwatch.svg";
import { transformChunks } from "shared/components/TextWrapper";
import { Button } from "ui/Button/Button";
import { BodyS, TitleM } from "ui/Typography/Typography";

export function TimedActivities() {
  const navigate = useNavigate();
  return (
    <Flex w="full" direction="column" gap="s200" data-testid="timed-activities-block">
      <TitleM mt="s100">
        <FormattedMessage id="pages.activities.main-activities.title" />
      </TitleM>

      <Flex bgColor="white" px="s200" py="s300" gap="s300" borderRadius="sm">
        <Image src={Stopwatch} boxSize="48px" borderRadius="full" />
        <Box>
          <BodyS mb="s100">
            <FormattedMessage
              id="pages.activities.main-activities.register.body"
              values={transformChunks({ b: { as: "strong" } })}
            />
          </BodyS>
          <Button
            variant="secondary"
            onClick={() => navigate(routes.activities.timedActivities.list)}
            data-testid="timed-activities-link"
          >
            <FormattedMessage id="pages.activities.main-activities.register.cta" />
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
}
